export const readCookie = (name: string): null | string => {
  const entry = document.cookie
    .split('; ')
    .find((cookie: string): boolean => cookie.startsWith(`${name}=`))

  return entry === undefined ? null : decodeURIComponent(entry.slice(name.length + 1))
}

export const writeCookie = (name: string, value: string, maxAgeSeconds: number): void => {
  const secure = window.location.protocol === 'https:' ? '; secure' : ''

  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeSeconds}; samesite=lax${secure}`
}

export const deleteCookie = (name: string): void => {
  document.cookie = `${name}=; path=/; max-age=0`
}
